import axios from "axios";

const state = {
  usuarioBodega: null,
};

const getters = {
  usuarioBodega: (state) => state.usuarioBodega,
};

const mutations = {
  setUsuarioBodega: (state, usuarioBodega) => {
    state.usuarioBodega = usuarioBodega;
  },
};

const actions = {
  async consultar({ commit }) {
    try {
      const res = await axios.get(`/v1/usuario-bodega/vehiculo`);
      commit("setUsuarioBodega", res?.data?.result);
    } catch (error) {
      commit("setUsuarioBodega", []);
      return error;
    }
  },
  async consultarBodegaTecnico({ commit }) {
    try {
      const res = await axios.get(`/v1/usuario-bodega/tecnico`);
      commit("setUsuarioBodega", res?.data?.result);
    } catch (error) {
      commit("setUsuarioBodega", []);
      return error;
    }
  },
  async consultarBodegaUsuario({ commit }, data) {
    try {
      const res = await axios.get(`/v1/usuario-bodegas/${data.idUsuario}/usuario`);
      commit("setUsuarioBodega", res?.data?.result);
    } catch (error) {
      commit("setUsuarioBodega", []);
      return error;
    }
  },

  async eliminar({ commit }, data) {
    try {
       await axios.delete(`/v1/usuario-bodegas/${data.id}`);
      commit("setUsuarioBodega", []);
    } catch (error) {
      return error;
    }
  },
  async consultarTodos() {
    try {
      const resp = await axios.get(`/v1/usuario-bodegas/all`);
      return {
        success: true,
        data: resp.data,
      }
    } catch (error) {
      return {
        success: false,
        data: error.response.data.errors
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
